import { useState } from 'react';
import Box from '@mui/material/Box';
import TableContainer from '@mui/material/TableContainer';
import { Table } from '@components/Table';
import { Switch } from '@components/Switch';
import { useTranslation } from '@hooks';

const ImportValidationTable = ({ columnNames, rows, hasError }) => {
    const { t } = useTranslation();
    const [showErrorsOnly, setShowErrorsOnly] = useState(false);

    const errorCount = hasError.filter(Boolean).length;
    const activeShowErrorsOnly = showErrorsOnly && errorCount > 0;
    const displayRows = activeShowErrorsOnly ? rows.filter((_, i) => hasError[i]) : rows;

    return (
        <>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', mb: 1 }}>
                <Switch
                    checked={activeShowErrorsOnly}
                    handleChange={e => setShowErrorsOnly(e.target.checked)}
                    label={
                        errorCount > 0
                            ? t('ImportValidationTable.showErrorsOnlyCount', { count: errorCount })
                            : t('ImportValidationTable.showErrorsOnly')
                    }
                    disabled={errorCount === 0}
                />
            </Box>
            <TableContainer>
                <Table withHover columnNames={columnNames} rows={displayRows} />
            </TableContainer>
        </>
    );
};

export default ImportValidationTable;
